import { JobState } from "@cayo/shared/services/jobState/types";
import { IAppTheme } from "@cayo/shared/themes/types";

const jobstate = (theme: IAppTheme, prms: JobState) => {
  return theme.getJobState(prms);
};

export const buildInIconFormatters = {
  jobstate,
};
